import { trackEvent } from '~src/tracking';
import { fetchAiCredits } from '~graphql/controllers';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { handleBuyAiCredits as handleBuyAiCreditsSwal } from './handleBuyAiCredits';

/**
 * Handler for AI credits purchase using the modal interface
 */
export const handleBuyAiCredits = async () => {
  try {
    // Fetch current credits to check if warning is needed
    const credits = await fetchAiCredits();
    const totalCredits =
      credits.edges[0].freeCreditsAmount + credits.edges[0].paidCreditsAmount;

    // Check if user has more than 100 credits
    if (totalCredits > 100) {
      const result = await Swal.fire({
        title: `Hai già ${totalCredits} crediti, sei sicuro di volerne comprare altri?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        confirmButtonColor: '#278e8e',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (!result.isConfirmed) {
        trackEvent('AI Credits Buy Modal', {
          step: 'too_many_credits_stop',
          balance: totalCredits,
        });
        return;
      } else {
        trackEvent('AI Credits Buy Modal', {
          step: 'too_many_credits_continue',
          balance: totalCredits,
        });
      }
    }

    // Track modal open
    trackEvent('AI Credits Buy Modal', {
      step: 'open_modal',
      balance: totalCredits,
    });

    // Show the credit packages modal
    $('#aiCreditPackagesModal').modal('show');
  } catch (error) {
    console.error('Error opening credit packages modal:', error);

    // Fallback to the original swal-based handler
    handleBuyAiCreditsSwal();
  }
};
